import Icon from './Icon';

const OfflineClassIcon = (props) => {
  const { height = 24, width = 24 } = props;
  return (
    <Icon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33301 3.33329C1.33301 2.9651 1.63148 2.66663 1.99967 2.66663H8.66634C9.03453 2.66663 9.33301 2.9651 9.33301 3.33329V13.3333H1.99967C1.63148 13.3333 1.33301 13.0348 1.33301 12.6666V3.33329ZM3.33309 6.99997C3.33309 6.63178 3.63157 6.3333 3.99976 6.3333H6.66642C7.03461 6.3333 7.33309 6.63178 7.33309 6.99997C7.33309 7.36816 7.03461 7.66664 6.66642 7.66664H3.99976C3.63157 7.66664 3.33309 7.36816 3.33309 6.99997ZM3.99976 8.3333C3.63157 8.3333 3.33309 8.63178 3.33309 8.99997C3.33309 9.36816 3.63157 9.66664 3.99976 9.66664H6.66642C7.03461 9.66664 7.33309 9.36816 7.33309 8.99997C7.33309 8.63178 7.03461 8.3333 6.66642 8.3333H3.99976Z"
        fill="#EB5757"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.33301 6.66663H13.9997C14.3679 6.66663 14.6663 6.9651 14.6663 7.33329V12.6666C14.6663 13.0348 14.3679 13.3333 13.9997 13.3333H9.33301V6.66663ZM10.9998 8.99997C10.9998 8.63178 11.2982 8.3333 11.6664 8.3333H12.3331C12.7013 8.3333 12.9998 8.63178 12.9998 8.99997C12.9998 9.36816 12.7013 9.66664 12.3331 9.66664H11.6664C11.2982 9.66664 10.9998 9.36816 10.9998 8.99997ZM11.6664 10.3333C11.2982 10.3333 10.9998 10.6318 10.9998 11C10.9998 11.3682 11.2982 11.6666 11.6664 11.6666H12.3331C12.7013 11.6666 12.9998 11.3682 12.9998 11C12.9998 10.6318 12.7013 10.3333 12.3331 10.3333H11.6664Z"
        fill="#EB5757"
      />
    </Icon>
  );
};

OfflineClassIcon.propTypes = Icon.proptypes;
OfflineClassIcon.defaultProps = Icon.defaultProps;

export default OfflineClassIcon;
